import { defineAsyncComponent } from 'vue';

export * from './components/SubtaskCount';

export const subtaskMicroFrontends = {
	SubtaskList: defineAsyncComponent(
		() => import('./components/SubtaskList/SubtaskList.vue')
	),
};
